/** ECharts MapComponent 内部 roam zoom（可到上万）。大于等于则显示单点而非项目聚合。 */
export const CLUSTER_ZOOM_THRESHOLD = 100

/**
 * 天地图 JS `map.getZoom()` 约 4–18。大于等于则显示单仪器点；小于则显示项目「总点」聚合（对齐 2D：zoom<100 聚合 / ≥100 单点）。
 * 项目聚焦 zoom 应始终小于本值，避免未放大就展开。
 */
export const TIANDITU_JS_DETAIL_ZOOM_THRESHOLD = 14

export function buildProjectClusters(stations = []) {
  if (!stations || stations.length === 0) return []

  const groups = {}
  stations.forEach((s) => {
    const projectId = s.project_name || '未知项目'
    if (!groups[projectId]) {
      groups[projectId] = {
        name: projectId,
        count: 0,
        lngSum: 0,
        latSum: 0,
        statusPriority: 0, // 0: normal, 1: warning, 2: error
        stations: []
      }
    }
    const g = groups[projectId]
    g.count += 1
    g.lngSum += s.value?.[0] || 0
    g.latSum += s.value?.[1] || 0
    g.stations.push(s)

    // statusPriority: 0 normal, 1 yellow, 2 orange, 3 red
    let p = 0
    if (s.status === 'yellow') p = 1
    if (s.status === 'orange') p = 2
    if (s.status === 'red') p = 3
    if (p > g.statusPriority) g.statusPriority = p
  })

  const statusMap = { 0: 'normal', 1: 'yellow', 2: 'orange', 3: 'red' }
  return Object.values(groups).map((g) => ({
    name: `${g.name} (${g.count}个设备)`,
    value: [g.lngSum / g.count, g.latSum / g.count, 50],
    status: statusMap[g.statusPriority],
    isCluster: true,
    projectName: g.name,
    children: g.stations
  }))
}

